import React, { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faLightbulb,
    faPaperPlane,
    faPen,
} from '@fortawesome/free-solid-svg-icons'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { AppContextMenu } from '../../App'

const SendEmployeeIdea = () => {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('sendEmployeeIdea')
    }, [])
    const [loading, setLoading] = useState(false)
    const [content, setContent] = useState('')

    const handleSubmit = async () => {
        if (!content.trim()) {
            toast.error('لطفاً متن ایده را وارد کنید', {
                position: 'bottom-center',
            })
            return
        }
        setLoading(true)

        await RequestQueue.sendRequest({
            config: {
                method: 'post',
                url: `/employee-idea`,
                data: { content: content.trim() },
            },
            resolve: () => {
                toast.dismiss()
                toast.success('ایده شما با موفقیت ثبت شد', {
                    position: 'bottom-center',
                })
                setContent('')
                setLoading(false)
            },
            reject: () => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg border border-gray-200 mx-4 my-6">
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-amber-500 to-orange-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faLightbulb}
                                    className="ml-2"
                                />
                                ثبت ایده
                            </h2>
                        </div>

                        <div className="p-6 space-y-6">
                            <div className="space-y-2">
                                <label className="text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faPen}
                                        className="ml-2"
                                    />
                                    ایده شما
                                </label>
                                <textarea
                                    rows={5}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
                                    placeholder="ایده یا پیشنهاد خود را اینجا بنویسید..."
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                />
                            </div>

                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col">
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className="px-6 py-3 rounded-xl text-white bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faPaperPlane}
                                        className="ml-2"
                                    />
                                    ارسال ایده
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default SendEmployeeIdea
